import { useTranslation } from 'react-i18next';
import { AppModal } from '@components/form/Modal';
import { formatAmount } from '@modules/settings/subscription/utils/utils';
import { formatOrderType } from './confirm-payment.helpers';

type Props = {
  open: boolean;
  amount: number;
  type?: string | null;
  rejecting: boolean;
  onKeepRequest: VoidFunction;
  onCancelRequest: VoidFunction;
};

export function CancelPaymentRequestModal({ open, amount, type, rejecting, onKeepRequest, onCancelRequest }: Props) {
  const { t } = useTranslation();

  return (
    <AppModal
      width={420}
      title={
        <AppModal.Header>
          <AppModal.Title>{t('cancel_payment_request_title')}</AppModal.Title>
        </AppModal.Header>
      }
      open={open}
      onCancel={onKeepRequest}
      footer={
        <AppModal.Footer>
          <AppModal.Button className="w-full capitalize!" onClick={onKeepRequest} disabled={rejecting}>
            {t('keep_request')}
          </AppModal.Button>
          <AppModal.Button
            danger
            type="primary"
            className="w-full capitalize!"
            loading={rejecting}
            onClick={onCancelRequest}
          >
            {t('cancel_request')}
          </AppModal.Button>
        </AppModal.Footer>
      }
    >
      <AppModal.Body>
        <p className="text-text-500 text-sm">{t('are_you_sure_you_want_to_cancel_this_payment_request')}</p>
        <p className="text-text-500 text-sm mt-4">
          {t('cancel_payment_request_message_{amount}', { amount: formatAmount(amount) })}{' '}
          <span className="text-text-800 font-semibold">{formatOrderType(type)}</span>
          {'. '}
          {t('no_payment_will_be_processed')}
        </p>
      </AppModal.Body>
    </AppModal>
  );
}
